import Input from "components/Input";

import { ReactComponent as UniconIcon } from 'icons/components/unicon.svg';

export default class SumInput extends Input {

    static propTypes = {
        ...Input.propTypes,
    };

    static defaultProps = {
        ...Input.defaultProps,
        type: "number",
        placeHolder: "0.00",
        inputProps: {
            step: 0.01,
        },
        translate: true,
        iconRight: <UniconIcon />
    };
}
